import {
  Box,
  Button,
  Card,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd"; // Total Advisors
import FolderOpenIcon from "@mui/icons-material/FolderOpen"; // Open Cases
import DoneAllIcon from "@mui/icons-material/DoneAll"; // Close Cases
import AllInboxIcon from "@mui/icons-material/AllInbox"; // All Cases
import SmsFailedIcon from "@mui/icons-material/SmsFailed";

import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import FilterListIcon from "@mui/icons-material/FilterList";

import CancelIcon from "@mui/icons-material/Cancel";
import { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import { _get_dashboard_data } from "../../../DAL/adminAuth/auth";
import moment from "moment";
import CustomDrawer from "../../../components/customComponents/drawer/CustomDrawer";
import DashboardFilter from "./FilterDashboard";
// import { _get_dashboard_data } from "../../DAL/Login/Login";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
    marginBottom: "10%",
  },
}));

export default function Dashboard() {
  const new_valyues = {
    deleteRecordingId: null,
    deleteDialogOpen: false,
    drawerOpen: false,
    selectedCategory: null,
    change_advisor_status_drawer: false,
    select_change_drawer_advisor: null,
    change_case_status_drawer: false,
    select_change_drawer_case: null,
    image: "",
  };
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [recordingListState, setRecordingListState] = useState(new_valyues);
  const [selectedOccurancePeriod, setSelectedoccurancePeriod] = useState(null);

  const theme = useTheme();

  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [tempFilters, setTempFilters] = useState({
    startDate: null,
    endDate: null,
    occurrencePeriod: null,
  });
  const handleopenFilterDrawer = () => {
    setRecordingListState((old) => ({
      ...old,
      drawerOpen: true,
      selectedCategory: null,
    }));
  };

  const FetchDashboard = async (start_date, end_date) => {
    const startDateParam = start_date
      ? moment(start_date).format("YYYY-MM-DD")
      : ""
      ? moment(startDate).format("YYYY-MM-DD")
      : "";

    const endDateParam = end_date
      ? moment(end_date).format("YYYY-MM-DD")
      : ""
      ? moment(endDate).format("YYYY-MM-DD")
      : "";
    setIsLoading(true);
    console.log(startDateParam, endDateParam, "ednkajdg");

    const result = await _get_dashboard_data(startDateParam, endDateParam);
    console.log(result, "resultresultresultresult");
    if (result.code === 200) {
      setDashboardData(result);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  useEffect(() => {
    FetchDashboard();
  }, []);

  const cardItems = [
    {
      title: "Total Attorneys",
      key: "advisor_count",
      icon: <AssignmentIndIcon />,
      gradient: "linear-gradient(135deg, #3949AB, #5C6BC0)", // Bold indigo
    },
    {
      title: "Pending Cases",
      key: "open_Cases_count",
      icon: <FolderOpenIcon />,
      gradient: "linear-gradient(135deg, #F57C00, #FFA726)", // Rich tangerine-orange
    },
    {
      title: "Recovered Cases",
      key: "closed_Cases_count",
      icon: <DoneAllIcon />,
      gradient: "linear-gradient(135deg, #2E7D32, #81C784)", // Balanced forest-green
    },
    {
      title: "Assigned Cases",
      key: "assined_cases_count",
      icon: <AssignmentTurnedInIcon />,
      gradient: "linear-gradient(135deg, #6e4b45, #6e4b45)", // Dark Brown to Coffee
    },
    {
      title: "Failed Cases",
      key: "failed_cases_count",
      icon: <SmsFailedIcon />,
      gradient: "linear-gradient(135deg, #D32F2F, #d7635b)", // Bright red gradient
    },
    {
      title: "All Cases",
      key: "all_Cases_count",
      icon: <AllInboxIcon />,
      gradient: "linear-gradient(135deg, #455A64, #78909C)", // Cool slate-blue
    },
  ];

  const cardStyle = {
    height: 180,
    borderRadius: "16px",
    p: 3,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    textAlign: "left",
    flex: 1,
    minWidth: 250,
    color: "#ffffff",
    transition: "all 0.3s ease",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.12)",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  };
  const handleCloseDrawer = () => {
    setRecordingListState((old) => ({ ...old, drawerOpen: false }));
  };

  const applyFilters = () => {
    setTempFilters({
      startDate: startDate,
      endDate: endDate,
      occurrencePeriod: selectedOccurancePeriod,
    });
    handleCloseDrawer();
    FetchDashboard(startDate, endDate);
  };

  const clearFilters = () => {
    setTempFilters((prev) => ({ ...prev, startDate: null }));
    setTempFilters((prev) => ({ ...prev, endDate: null }));
    setTempFilters((prev) => ({ ...prev, occurrencePeriod: null }));
    setSelectedoccurancePeriod(null);
    FetchDashboard("", "");
    handleCloseDrawer();
  };
  const iconContainerStyle = {
    width: 48,
    height: 48,
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: 2,
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  };
  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <Box sx={{ p: 3 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            mb: 2,
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 600, fontSize: 32 }}>
            Dashboard
          </Typography>
          <Button
            sx={{
              height: "38px",
              alignSelf: { xs: "flex-start", sm: "center" },
            }}
            variant="contained"
            startIcon={<FilterListIcon />}
            onClick={handleopenFilterDrawer}
          >
            Filters
          </Button>
        </Box>

        {(tempFilters.startDate || tempFilters.endDate) && (
          <div className="mb-3 d-flex flex-wrap align-items-center gap-2">
            {tempFilters.startDate && (
              <div className="filter-chip">
                Start Date: {moment(tempFilters.startDate).format("YYYY-MM-DD")}
                <span
                  className="chip-close"
                  onClick={() => {
                    setStartDate(null);
                    setEndDate(null);
                    setSelectedoccurancePeriod(null);

                    setTempFilters((prev) => ({
                      ...prev,
                      startDate: null,
                      endDate: null,
                      occurrencePeriod: null,
                    }));
                    FetchDashboard("", "");
                  }}
                >
                  ×
                </span>
              </div>
            )}
            {tempFilters.endDate && (
              <div className="filter-chip">
                End Date: {moment(tempFilters.endDate).format("YYYY-MM-DD")}
                <span
                  className="chip-close"
                  onClick={() => {
                    setStartDate(null);
                    setEndDate(null);
                    setSelectedoccurancePeriod(null);

                    setTempFilters((prev) => ({
                      ...prev,
                      startDate: null,
                      endDate: null,
                      occurrencePeriod: null,
                    }));
                    FetchDashboard("", "");
                  }}
                >
                  ×
                </span>
              </div>
            )}

            <button
              className="btn btn-sm filter-chip-clear-all"
              onClick={() => {
                setStartDate(null);
                setEndDate(null);
                setSelectedoccurancePeriod(null);

                setTempFilters({
                  startDate: null,
                  endDate: null,
                  occurrencePeriod: null,
                });
                FetchDashboard("", "");
              }}
            >
              Clear All <span className="chip-close clear-all">✕</span>
            </button>
          </div>
        )}

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: 3,
            pb: 2,
          }}
        >
          {cardItems.map((item, index) => (
            <Card
              key={index}
              sx={{
                ...cardStyle,
                background: item.gradient,
              }}
            >
              <Box sx={iconContainerStyle}>{item.icon}</Box>
              <Box>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "rgba(255,255,255,0.85)" }}
                >
                  {item.title}
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 0.5 }}>
                  {item?.isCurrency
                    ? `$${(dashboardData[item.key] || 0).toLocaleString()}`
                    : dashboardData[item.key] ?? 0}
                </Typography>
              </Box>
            </Card>
          ))}
        </Box>
      </Box>
      <CustomDrawer
        isOpenDrawer={recordingListState.drawerOpen}
        // onOpenDrawer={handleCloseDrawer}
        onCloseDrawer={handleCloseDrawer}
        pageTitle={`${
          recordingListState.selectedCategory ? "Filters" : "Filters"
        } `}
        componentToPassDown={
          <DashboardFilter
            onCloseDrawer={handleCloseDrawer}
            selectedObject={recordingListState.selectedCategory}
            refreshList={FetchDashboard}
            applyFilters={applyFilters}
            endDate={endDate}
            setEndDate={setEndDate}
            startDate={startDate}
            setStartDate={setStartDate}
            clearFilters={clearFilters}
            tempFilters={tempFilters}
            setTempFilters={setTempFilters}
            setSelectedoccurancePeriod={setSelectedoccurancePeriod}
            selectedOccurancePeriod={selectedOccurancePeriod}
          />
        }
      />
    </>
  );
}
